<div class="container" (clickOutside)="showDropdown = false">
	<ng-container *ngIf="theme === 'time'">
		<input [(ngModel)]="timeInput" name="timeSelection" type="text" (click)="showDropdown = true" (keydown)="searchTerm.next($event)"
		(ngModelChange)="timeInputChanged()"
		/>
	
		<div class="dropdown" *ngIf="showDropdown">
			<ul>
				<li *ngFor="let option of times" (click)="selectTime(option)">{{ option.label }}</li>
			</ul>
		</div>
	
		<div class="right-button">
			<i class="fa fa-chevron-down"></i>
		</div>
	</ng-container>

	<ng-container *ngIf="theme === 'embargo'">
		  <mat-form-field appearance="fill" class="full-width">
			<mat-label>{{"SET_TIME" | translate}}</mat-label>
			<mat-select [(ngModel)]="timeInput" name="embargo_time" (ngModelChange)="timeInputChanged()">
				<mat-option *ngFor="let option of times" [value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>
</div>
